// src/pages/ConferenceDetails.js
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./ConferencePage.css";

const API_URL =
  process.env.REACT_APP_API_URL?.trim() ||
  "https://us-central1-ottomun-87f07.cloudfunctions.net/api/api";

const ConferenceDetails = () => {
  const { id } = useParams();
  const [conference, setConference] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConference = async () => {
      try {
        const res = await fetch(`${API_URL}/conferences/${id}`);
        const data = await res.json();
        setConference(data);
      } catch (error) {
        console.error("❌ Error fetching conference:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchConference();
  }, [id]);

  if (loading)
    return <p style={{ textAlign: "center", marginTop: "100px" }}>Loading...</p>;

  if (!conference)
    return <p style={{ textAlign: "center", marginTop: "100px" }}>Not found.</p>;

  return (
    <section className="conference-modern">
      <header className="conference-header">
        <h1>{conference.title}</h1>
        <p>
          {conference.date} • {conference.location}
        </p>
      </header>

      <motion.div
        key="about"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="about-section"
      >
        <h2>About {conference.title}</h2>
        <p>{conference.about || "No information added yet."}</p>
      </motion.div>

      <Link to="/" className="back-btn main">← Back to Home</Link>
    </section>
  );
};

export default ConferenceDetails;
